export default "/images/tiutLogo.png?e8da5174f4c039122147ee46404343b8";